<template>
  <div
    class="rich-select country_picker"
    :class="{'rich-select_active': showSel}"
    @click="showPicker"
  >
    <span slot="title">{{title}}</span>
    <span v-html="checkStatus" class="content"></span>
    <i class="rich-select-icon"></i>
  </div>
</template>

<script>
import { i18n } from '@/common/utils/i18n'
import { mapState } from 'vuex'
import { get } from 'lodash-es'
const EVENT_INPUT = 'input'
const EVENT_CANCEL = 'cancel'
export default {
  name: 'DatePicker',
  data () {
    return {
      showSel: false
    }
  },
  props: {
    title: {
      type: String,
      default: String
    },
    placeholder: {
      type: String,
      default: String
    },
    value: {
      type: Array
    }
  },
  computed: {
    ...mapState({
      countryConfig: state => state.countryConfig
    }),
    checkStatus () {
      return this.value ? this.info : this.placeholder
    },
    info () {
      if (this.isIncludeThisCountry()) {
        if (get(this.value, 'length') && get(this.countryConfig, 'length') > 0) {
          let country = this.value[0] // 国家
          let timezone = this.value[1] // 时区
          let countryText = this.countryConfig.filter((item) => {
            return item.value === country
          })
          return countryText.length && ((countryText[0].text || '') + '/' + (timezone || ''))
        } else {
          return `<span class="rich-select-placeholder">${i18n.gettext('请选择')}</span>`
        }
      } else {
        return `<span class="rich-select-placeholder">${i18n.gettext('请选择')}</span>`
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    selectedIndex () {
      if (this.isIncludeThisCountry()) {
        if (get(this.value, 'length') && get(this.countryConfig, 'length') > 0) {
          let country = this.value[0] // 国家
          let countryText = this.countryConfig.filter((item) => {
            return item.value === country
          })
          return countryText.length && [countryText[0].index, 0]
        }
      } else {
        return []
      }
    }
  },
  methods: {
    // getuserinfo里面的国家信息是否在getUserAuthCountry接口中，不在地区和语言都要展示"请选择"
    isIncludeThisCountry () {
      return get(this.value, 'length') && this.countryConfig.map((item) => {
        return item.value
      }).includes(this.value[0])
    },
    showPicker () {
      this.picker = this.$createCascadePicker({
        $class: {
          'country-cascade-picker': true
        },
        title: i18n.gettext('请选择'),
        data: this.countryConfig || [],
        selectedIndex: this.selectedIndex,
        onSelect: this.selectHandler,
        onCancel: this.cancelHandler
      }).show()
      this.showSel = true
    },
    selectHandler (date, selectedVal, selectedText) {
      this.$emit(EVENT_INPUT, date)
      this.showSel = false
    },
    cancelHandler () {
      this.$emit(EVENT_CANCEL)
      this.showSel = false
    }
  }
}

</script>

<style lang="stylus" rel="stylesheet/stylus">
  .country_picker{
    .content{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 90%;
    }
  }
  .country-cascade-picker .rich-picker-wheel-item {
    font-size: 32px;
  }
</style>
